import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BentoAlertItemOptions } from '@bento/bento-ng';



@Injectable({
	providedIn: 'root'
})

export class SiteSettingsService {
	alerts: BentoAlertItemOptions[] = [];
	constructor(private http: HttpClient) { }

	async getFirmThemes(companyId: string) {

		let header: HttpHeaders = new HttpHeaders();
		header = header.append('Content-Type', 'application/json');
		header = header.append('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, DELETE');
		header = header.append('Access-Control-Allow-Headers', 'Content-Type');

		return this.http.get('/api/profiles/v1/themes?company=' + companyId, { headers: header })
			.toPromise()
			.catch((e) => {
				throw new Error(e.message);
			});
	}

	async getBannerThemeEntry(companyId: string) {
		const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

		return this.http.get('/api/profiles/v1/themes/banner?company=' + companyId, { headers, responseType: 'text' })
			.toPromise()
			.catch((e) => {
				throw new Error(e.message);
			});
	}

	async getBannerImage(companyId: string) {
		return this.http.get('/api/profiles/v1/themes/banner?company=' + companyId, { responseType: 'blob' })
			.toPromise()
			.catch((e) => {
				throw new Error(e.message);
			});
	}

	async getLogoImage(companyId: string) {
		return this.http.get('/api/profiles/v1/themes/logo?company=' + companyId, { responseType: 'blob' })
			.toPromise()
			.catch((e) => {
				throw new Error(e.message);
			});
	}

	async getHeaderImage(companyId: string) {
		return this.http.get('/api/profiles/v1/themes/header-image?company=' + companyId, { responseType: 'blob' })
			.toPromise()
			.catch((e) => {
				throw new Error(e.message);
			});
	}

}
